export const SOLO_PRICE = 14500;

export const TIERS = [
  { id: "solo", qty: 1, total: 14500 },
  { id: "duo", qty: 2, total: 25000 },
  { id: "reseau", qty: 3, total: 29700 },
];

export const quote = (qty) => {
  const tier = TIERS.find((x) => x.qty === Number(qty));
  if (!tier) return null;
  const deposit = Math.round(tier.total * 0.3);
  return { ...tier, unit: tier.total / tier.qty, deposit, balance: tier.total - deposit, saving: SOLO_PRICE * tier.qty - tier.total };
};

export const UPSELL_DIFF = 29700 - 25000;
